export const TOURNAMENT_TOAST_MINUTES = [5, 2] as const;

export const TOURNAMENT_BRACKET_SIZES = [4, 8, 16, 32] as const;
export type TournamentBracketSize = (typeof TOURNAMENT_BRACKET_SIZES)[number];

export const TOURNAMENT_RECURRENCES = ["hourly", "daily", "weekly", "custom"] as const;
export type TournamentRecurrence = (typeof TOURNAMENT_RECURRENCES)[number];

export { parseRecurrenceInterval, formatRecurrenceInterval } from "../../../lib/tournamentConstants";

export const TOURNAMENT_MODE_IDS = [
  "normal", "wasd", "superdot", "roulette", "sandbox", "highway", "darkness",
  "mirror", "snake", "combo", "colorrush", "heat", "hunter", "pop", "counter",
  "aim", "hook", "tilt", "orbit", "delay", "progression",
] as const;

export const TOURNAMENT_MODE_LABELS: Record<string, string> = {
  normal: "NORMAL", wasd: "WASD", superdot: "SUPERDOT", roulette: "ROULETTE",
  sandbox: "SANDBOX", highway: "HIGHWAY", darkness: "DARKNESS", mirror: "MIRROR",
  snake: "SNAKE", combo: "COMBO", colorrush: "COLOR RUSH", heat: "HEAT",
  hunter: "HUNTER", pop: "POP", counter: "COUNTER", aim: "AIM", hook: "HOOK",
  tilt: "TILT", orbit: "ORBIT", delay: "DELAY", progression: "PROGRESSION",
};

export type TournamentMatchModeConfig = {
  matchIndex: number;
  modeId: string;
  levelIndex?: number | null;
};

export type TournamentRoundRewards = Record<string, number>;

export function tournamentMatchCount(bracketSize: number): number {
  return Math.max(0, bracketSize - 1);
}

export function tournamentModeLabel(modeId: string): string {
  return TOURNAMENT_MODE_LABELS[modeId] ?? String(modeId).toUpperCase();
}

export function tournamentUsesLevelMetric(modeId: string): boolean {
  return modeId === "progression";
}

export type TournamentSummary = {
  id: string;
  name: string;
  bracketSize: number;
  status: string;
  startsAt: string;
  registeredCount: number;
  registered: boolean;
  winnerUserId: string | null;
  winnerName: string | null;
};

export type TournamentMatchPlayer = {
  userId: string;
  displayName: string | null;
  score: number | null;
  finished: boolean;
  joined: boolean;
};

export type TournamentMatchView = {
  id: string;
  matchIndex: number;
  round: number;
  modeId: string;
  levelIndex: number | null;
  status: string;
  generation: number;
  windowStart: string | null;
  windowEnd: string | null;
  tieRestartAt: string | null;
  winnerUserId: string | null;
  player1: TournamentMatchPlayer | null;
  player2: TournamentMatchPlayer | null;
  viewerSlot: number;
  opponentScore: number | null;
  opponentFinished: boolean;
};

export type TournamentDetail = {
  id: string;
  name: string;
  bracketSize: number;
  status: string;
  startsAt: string;
  registeredCount: number;
  registered: boolean;
  winnerUserId: string | null;
  winnerName: string | null;
  roundRewards: Record<string, number>;
  registrations: Array<{
    userId: string;
    displayName: string | null;
    seed: number | null;
    registeredAt: string;
  }>;
  matches: TournamentMatchView[];
};
